export type InterviewFeedbackCategoryTitle =
  | 'Depth of the experiences'
  | 'Coherence'
  | 'Role-related Knowledge & Experiences'
  | 'Team Skills'
  | 'Communication Skills'
  | 'Problem-Solving' // temp
  | 'Adaptability' // temp
  | 'Leadership & Initiative' // temp
  | 'Time Management' // temp
  | 'Resilience & Stress Management' // temp
  | 'Creativity & Innovation' // temp
  | 'Attention to Detail' // temp
  | 'Ethical Decision-Making' // temp
  | 'Strategic & Analytical Thinking' // temp
  | 'Work Ethic & Professionalism' // temp

export const possibleInterviewFeedbackCategories: InterviewFeedbackCategoryTitle[] = [
  'Depth of the experiences',
  'Coherence',
  'Role-related Knowledge & Experiences',
  'Team Skills',
  'Communication Skills'
]

export type InterviewFeedbackCategoriesScore = {
  [key in InterviewFeedbackCategoryTitle]: {
    breakpoints: number[]
    description: string
  }
}

export const allInterviewFeedbackCategories: InterviewFeedbackCategoryTitle[] = [
  'Depth of the experiences',
  'Coherence',
  'Role-related Knowledge & Experiences',
  'Team Skills',
  'Communication Skills',
  'Problem-Solving',
  'Adaptability',
  'Leadership & Initiative',
  'Time Management',
  'Resilience & Stress Management',
  'Creativity & Innovation',
  'Attention to Detail',
  'Ethical Decision-Making',
  'Strategic & Analytical Thinking',
  'Work Ethic & Professionalism'
]

export const interviewFeedbackCategoriesScore: InterviewFeedbackCategoriesScore = {
  'Depth of the experiences': {
    breakpoints: [15, 20, 30],
    description:
      'Assesses the richness, relevance, and depth of experiences in relation to the role or field.'
  },
  Coherence: {
    breakpoints: [10, 15, 20],
    description:
      'Evaluates how well ideas and responses are structured, logically connected, and easy to follow.'
  },
  'Role-related Knowledge & Experiences': {
    breakpoints: [12, 16, 20],
    description:
      'Measures familiarity with key concepts, best practices, and hands-on experiences relevant to the role.'
  },
  'Team Skills': {
    breakpoints: [8, 12, 15],
    description:
      'Assesses collaboration, contribution to team efforts, and ability to work effectively in a group setting.'
  },
  'Communication Skills': {
    breakpoints: [8, 12, 15],
    description:
      'Evaluates clarity, articulation, and effectiveness in verbal and written communication.'
  },
  'Problem-Solving': {
    breakpoints: [8, 12, 15],
    description:
      'Measures the ability to analyze challenges, think critically, and develop effective solutions.'
  },
  Adaptability: {
    breakpoints: [8, 12, 15],
    description:
      'Examines flexibility in response to new situations, ability to learn quickly, and resilience in dynamic environments.'
  },
  'Leadership & Initiative': {
    breakpoints: [8, 12, 15],
    description:
      'Assesses proactiveness, decision-making, and the ability to take charge in tasks or projects.'
  },
  'Time Management': {
    breakpoints: [8, 12, 15],
    description:
      'Measures the ability to prioritize tasks, meet deadlines, and manage workload effectively.'
  },
  'Resilience & Stress Management': {
    breakpoints: [8, 12, 15],
    description:
      'Evaluates the ability to handle pressure, maintain focus, and recover from setbacks effectively.'
  },
  'Creativity & Innovation': {
    breakpoints: [8, 12, 15],
    description:
      'Assesses originality in ideas, problem-solving through innovative thinking, and creative contributions.'
  },
  'Attention to Detail': {
    breakpoints: [8, 12, 15],
    description:
      'Examines attention to detail, thoroughness in work, and ability to minimize errors.'
  },
  'Ethical Decision-Making': {
    breakpoints: [8, 12, 15],
    description:
      'Evaluates integrity, moral reasoning, and the ability to make ethically sound decisions.'
  },
  'Strategic & Analytical Thinking': {
    breakpoints: [8, 12, 15],
    description:
      'Measures the ability to think ahead, make long-term plans, and develop structured approaches to complex issues.'
  },
  'Work Ethic & Professionalism': {
    breakpoints: [8, 12, 15],
    description:
      'Measures dedication to work, reliability, and maintaining a high standard of professional behavior.'
  }
}

export const defaultInterviewFeedbackCategories: InterviewFeedbackCategoryTitle[] = [
  'Depth of the experiences',
  'Coherence',
  'Role-related Knowledge & Experiences',
  'Team Skills',
  'Communication Skills'
]

export type InterviewFeedbackCategoryCard = {
  category: InterviewFeedbackCategoryTitle
  score: number
  feedback: {
    text: string
    nature: 'positive' | 'negative'
  }[]
}

export type InterviewAIAgentSettingForm = {
  rubrics: string[]
  weightage: number[]
  questions: string[]
  prompt: string
}
